import { Select as CarbonSelect, SelectItem } from '@carbon/react';
import type { ComponentProps } from 'react';

type CarbonSelectProps = ComponentProps<typeof CarbonSelect>;

export interface CdSelectOption {
  value: string;
  label: string;
}

export interface CdSelectProps extends Omit<CarbonSelectProps, 'children'> {
  options: CdSelectOption[];
}

export const CdSelect = ({ options, ...rest }: CdSelectProps) => {
  return (
    <CarbonSelect {...rest}>
      {options.map((o) => (
        <SelectItem key={o.value} value={o.value} text={o.label} />
      ))}
    </CarbonSelect>
  );
};
